import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import StaffLayout from "./StaffLayout";
import { FUNCTIONALITIES, STAFF_BASE, staffDefaultRoute } from "./config";

// Builds the nested route tree for /gestion-staff from the nav config so the
// sub-menu and the routes never drift apart. One child route per sub-item, plus
// index redirects (section -> first functionality, functionality -> dashboard).
const children: RouteObject[] = [
  { index: true, element: <Navigate to={staffDefaultRoute} replace /> },
];

for (const f of FUNCTIONALITIES) {
  children.push({
    path: f.slug,
    element: <Navigate to={`${STAFF_BASE}/${f.slug}/${f.menu[0].id}`} replace />,
  });
  for (const item of f.menu) {
    children.push({ path: `${f.slug}/${item.id}`, element: item.element });
  }
}

export const staffRoute: RouteObject = {
  path: STAFF_BASE,
  element: <StaffLayout />,
  children,
};
